import { getWebsiteRootDomain } from "@/lib/shared/getRootDomain"
import { getCookie, setCookie } from "@/lib/shared/useCookies"

import { ConsentMap, CookieCategory } from "./types"

export abstract class BaseConsentService {
  COOKIE_NAME = "myaccount_consent"

  public getStoredConsent(): ConsentMap | null {
    return getCookie(this.COOKIE_NAME) ?? null
  }
  protected storeConsent(consent: ConsentMap): void {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 1)
    setCookie(this.COOKIE_NAME, consent, {
      domain: getWebsiteRootDomain(),
      path: "/",
      expires,
    })
  }
  hasConsent(category: CookieCategory): boolean {
    const stored = this.getStoredConsent()
    return stored?.[category] ?? false
  }

  abstract runOnceCookieCategoryAccepted(
    category: CookieCategory,
    callback: () => void,
  ): void
  abstract init(): void
  abstract openPreferencesModal(): void
  updateConsent?(category: ConsentMap): void
}
